module.exports = __webpack_public_path__ + "img/qui_sommes_nous.4b66939b.jpg";